import React from "react";

export default function UserCard(props) {
  const broker = props.broker;
  const item = props.item;

  return (
    <div className="menuContainer addHight text">
      <div className="menuExchange uppercase">{item.username}</div>
      <div className={`menuExchange uppercase`}>{item.bb_sharing}%</div>

      {broker.nse === 1 ? (
        <div className="menuExchange">{item.b_nse}</div>
      ) : null}
      {broker.nsecash === 1 ? (
        <div className="menuExchange">{item.b_nsecash}</div>
      ) : null}
      {broker.mcx === 1 ? (
        <div className="menuExchange">
          {item.lot_volume === 0 ? item.b_mcx_lot : item.b_mcx_volume}
        </div>
      ) : null}
      {broker.mcx_options === 1 ? (
        <div className="menuExchange">{item.b_mcx_options}</div>
      ) : null}
      {broker.options === 1 ? (
        <div className="menuExchange">{item.b_options}</div>
      ) : null}
      {broker.comex === 1 ? (
        <div className="menuExchange">{item.b_comex}</div>
      ) : null}
      {broker.crypto === 1 ? (
        <div className="menuExchange">{item.b_crypto}</div>
      ) : null}
      {broker.forex === 1 ? (
        <div className="menuExchange">{item.b_forex}</div>
      ) : null}
      {broker.sgx === 1 ? (
        <div className="menuExchange">{item.b_sgx}</div>
      ) : null}
      {broker.us_stock === 1 ? (
        <div className="menuExchange">{item.b_us_stock}</div>
      ) : null}
      {broker.index === 1 ? (
        <div className="menuExchange">{item.b_index}</div>
      ) : null}
      {broker.dgcx === 1 ? (
        <div className="menuExchange">{item.b_dgcx}</div>
      ) : null}
      {broker.ncdex === 1 ? (
        <div className="menuExchange">{item.b_ncdex}</div>
      ) : null}

      {broker.nse === 1 ? (
        <div className="menuExchange">{item.bb_nse}</div>
      ) : null}
      {broker.nsecash === 1 ? (
        <div className="menuExchange">{item.bb_nsecash}</div>
      ) : null}
      {broker.mcx === 1 ? (
        <div className="menuExchange">{item.bb_mcx}</div>
      ) : null}
      {broker.mcx_options === 1 ? (
        <div className="menuExchange">{item.bb_mcx_options}</div>
      ) : null}
      {broker.options === 1 ? (
        <div className="menuExchange">{item.bb_options}</div>
      ) : null}
      {broker.comex === 1 ? (
        <div className="menuExchange">{item.bb_comex}</div>
      ) : null}
      {broker.crypto === 1 ? (
        <div className="menuExchange">{item.bb_crypto}</div>
      ) : null}
      {broker.forex === 1 ? (
        <div className="menuExchange">{item.bb_forex}</div>
      ) : null}
      {broker.sgx === 1 ? (
        <div className="menuExchange">{item.bb_sgx}</div>
      ) : null}
      {broker.us_stock === 1 ? (
        <div className="menuExchange">{item.bb_us_stock}</div>
      ) : null}
      {broker.index === 1 ? (
        <div className="menuExchange">{item.bb_index}</div>
      ) : null}
      {broker.dgcx === 1 ? (
        <div className="menuExchange">{item.bb_dgcx}</div>
      ) : null}
      {broker.ncdex === 1 ? (
        <div className="menuExchange">{item.bb_ncdex}</div>
      ) : null}
    </div>
  );
}
